module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value.id !== '') ? _c('div', [(_vm.value.category || _vm.scheduleEditing) ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Categoria:")])]), _vm._v(" "), (!_vm.alteredScheduleSaving) ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.categories,
      "value": _vm.value.category,
      "item-text": "name",
      "item-value": "id",
      "label": "",
      "single-line": "",
      "disabled": _vm.loadingNew || !_vm.scheduleEditing && _vm.value.id !== '',
      "bottom": ""
    },
    on: {
      "input": _vm.setSelectedScheduleCategory
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr', {
    staticClass: "mt-2 mb-2"
  })])] : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.value.itens.length > 1) ? _c('strong', [_vm._v("Itens:")]) : _c('strong', [_vm._v("Item:")])]), _vm._v(" "), (!_vm.alteredScheduleSaving) ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.loadingNew || !_vm.scheduleEditing && _vm.value.id !== '') ? [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, _vm._l((_vm.selectedItems), function(item) {
    return _c('v-list-tile', {
      key: item.id,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [(!item.priceVariations) ? [_c('span', [_vm._v(_vm._s(_vm._f("currency")(item.price)))])] : [_c('span', [_vm._v(_vm._s(_vm._f("currency")(item.priceTable[0].price)))]), (item.priceTable.length > 1) ? _c('span', [_vm._v(" e mais " + _vm._s(item.priceTable.length - 1) + "...")]) : _vm._e()]], 2)], 1)], 1)
  }), 1)] : [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "elevation-0"
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "search",
      "hide-details": "",
      "single-line": "",
      "placeholder": "Pesquisar itens"
    },
    model: {
      value: (_vm.searchItem),
      callback: function($$v) {
        _vm.searchItem = $$v
      },
      expression: "searchItem"
    }
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "disabled": _vm.filteredItens.length === 0,
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.selectAllItens($event)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "green darken-2"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('span', [_vm._v("Selecionar todos")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_vm._l((_vm.filteredItens), function(item, index) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          return _vm.addSelectedItem(item)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [(!item.priceVariations) ? [_c('span', [_vm._v(_vm._s(_vm._f("currency")(item.price)))])] : [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      }
    }, [_c('span', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_vm._v(_vm._s(_vm._f("currency")(item.priceTable[0].price)))]), (item.priceTable.length > 1) ? _c('span', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_vm._v(" e mais " + _vm._s(item.priceTable.length - 1) + "...")]) : _vm._e(), _vm._v(" "), _c('span', [_c('ul', _vm._l((item.priceTable), function(price, i) {
      return _c('li', {
        key: i
      }, [_vm._v(_vm._s(price.description) + " - " + _vm._s(_vm._f("currency")(price.price)))])
    }), 0)])])]], 2)], 1), _vm._v(" "), _c('v-list-tile-action', [(item.priceVariations) ? [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      }
    }, [(!_vm.itemSelected(item.id)) ? _c('v-icon', {
      attrs: {
        "slot": "activator",
        "color": "grey lighten-1"
      },
      slot: "activator"
    }, [_vm._v("\n                          crop_square\n                        ")]) : _c('v-icon', {
      attrs: {
        "slot": "activator",
        "color": "green darken-2"
      },
      slot: "activator"
    }, [_vm._v("\n                          done\n                        ")]), _vm._v(" "), _c('span', [_c('span', [_c('ul', _vm._l((item.priceTable), function(price, i) {
      return _c('li', {
        key: i
      }, [_vm._v(_vm._s(price.description) + " - " + _vm._s(_vm._f("currency")(price.price)))])
    }), 0)])])], 1)] : [(!_vm.itemSelected(item.id)) ? _c('v-icon', {
      attrs: {
        "slot": "activator",
        "color": "grey lighten-1"
      },
      slot: "activator"
    }, [_vm._v("\n                        crop_square\n                      ")]) : _c('v-icon', {
      attrs: {
        "slot": "activator",
        "color": "green darken-2"
      },
      slot: "activator"
    }, [_vm._v("\n                        done\n                      ")])]], 2)], 1), _vm._v(" "), (index + 1 < _vm.registeredItems.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2)], 1)]], 2)] : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr', {
    staticClass: "mt-2 mb-2"
  })])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b742bbc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/agendamento/ScheduleModal/itemDetails.vue
// module id = 513
// module chunks = 0 1